import { useContext } from 'react';
import { StudioContext, StudioContextProps } from 'src/providers/StudioContextProvider';

export function useStudioContext(): StudioContextProps {
  return useContext(StudioContext);
}
